export default __webpack_public_path__ + "static/media/cp_geo_pr.6c89e389.svg";